import { WAVE_PROD, WAVE_TEST } from '@anm/constants/domains';
import isDev from '@anm/helpers/is/isDev';

export const getProjectUrl = (id: string) => (isDev() ? `${WAVE_TEST}editor/#p=${id}` : `${WAVE_PROD}editor/#p=${id}`);
